import { useState, useEffect } from 'react'
import { backendClient } from '../api/backend'

/**
 * Fetches user type groups from the backend.
 * The backend returns translated labels based on Accept-Language header.
 *
 * Response shape: [{ key, label, items: [{ value, label, icon }] }]
 */
export function useUserTypes() {
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    backendClient.getUserTypes()
      .then((data) => {
        if (!cancelled) setGroups(data)
      })
      .catch((err) => {
        console.error('Failed to fetch user types:', err)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => { cancelled = true }
  }, [])

  return { groups, loading }
}
